// React import
import * as React from 'react';
// Standard layout imports
import Label from 'src/components/FormElements/Label';
import { ISubActivityModel } from 'src/Entities/Activity/Activity';
import Box from 'src/components/Box';
import Line from 'src/components/Line';
import { format, compareAsc } from 'date-fns';
import mapMarker from 'src/images/map_marker.png';
import Icon from 'src/components/Icon';
import Button from 'src/components/Button';
import SubActivityIsAdvertisement from './subActivityItemIsAdvertisement';
import AnimateHeight from 'react-animate-height';

interface IProps {
  subActivities: ISubActivityModel[];
}
const SubActivitiesComponentIsAdvertisement = ({ subActivities }: IProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const activities = React.useMemo(() => {
    return subActivities.sort((a, b) =>
      compareAsc(new Date(a.startDate), new Date(b.startDate))
    );
  }, [subActivities]);

  const mainActivity = React.useMemo(() => {
    return activities[0];
  }, [activities]);

  const remainingActivities = React.useMemo(() => {
    return activities.slice(1);
  }, [activities]);

  return (
    <Box>
      {mainActivity !== undefined && (
        <SubActivityIsAdvertisement subActivity={mainActivity} />
      )}
      {remainingActivities.length > 0 && (
        <>
          <AnimateHeight duration={500} height={isExpanded ? 'auto' : 0}>
            {remainingActivities
              .sort((a, b) =>
                compareAsc(new Date(a.startDate), new Date(b.startDate))
              )
              .map((sa, i) => (
                <SubActivityIsAdvertisement
                  subActivity={sa}
                  key={`${sa.lektionId} ${i}`}
                />
              ))}
          </AnimateHeight>
          <Button
            color="light"
            className="w-full justify-center is-gray uppercase"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'MINIMER DELAKTIVITETER' : 'VIS FLERE DELAKTIVITETER'}
            <Icon
              name={isExpanded ? 'chevron-up' : 'chevron-down'}
              className="ml2"
            />
          </Button>
        </>
      )}
    </Box>
  );
};

export default SubActivitiesComponentIsAdvertisement;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/Activity/subActivities.componentIsAdvertisement.tsx